import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from 'react-select/lib/Async';

import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

const styles = theme => ({
  input: {
    display: "flex",
    padding: 0,
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
  },
  valueErrorContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    "& p": {
      color: "#f44336",
    },
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: "absolute",
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}>
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  const classes = props.selectProps.error ? props.selectProps.classes.valueErrorContainer : props.selectProps.classes.valueContainer;
  return <div className={classes}>{props.children}</div>;
}

function CustomSelect({ ...props }) {
  const { multiple, classes, options, onChange, value, defaultValue, placeholder, error, loadOptions, id } = props;

  const components = {
    Control,
    NoOptionsMessage,
    Option,
    Placeholder,
    SingleValue,
    ValueContainer,
  };

  return (
    <AsyncSelect
      isMulti={multiple}
      error={error}
      classes={classes}
      styles={styles}
      defaultValue={defaultValue}
      value={value}
      options={options}
      components={components}
      placeholder={placeholder}
      onChange={onChange}
      loadOptions={loadOptions}
      id={id}
      noOptionsMessage={(a) => {
        if(a.inputValue.length >= 2)
          return 'No found';
        else
          return 'Type at least 2 letters to search...';
      }}
    />
  );
}

CustomSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  error: PropTypes.bool,
  defaultValue: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
};

export default withStyles(styles)(CustomSelect);
